import { useThemeName } from './useThemeName'
import { docuSignThemeName } from '../docusign-themes/docuSignThemeName'

export function useIsInk() {
  return useThemeName() === docuSignThemeName.ink
}
